import { render, staticRenderFns } from "./df-page-newsletter.vue?vue&type=template&id=1567c090&"
import script from "./df-page-newsletter.ts?vue&type=script&lang=js&"
export * from "./df-page-newsletter.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports